export type ClassSelectionScope = 'single_class' | 'multiple_classes' | 'all_classes';

export type ClassChangeType = 'swapped' | 'added' | 'removed' | 'replaced';

export const getClassSelectionScope = (selectedCount: number, availableCount: number): ClassSelectionScope => {
  if (selectedCount === 1) return 'single_class';
  if (availableCount > 0 && selectedCount === availableCount) return 'all_classes';
  return 'multiple_classes';
};

export const getClassChangeType = (before: string[], after: string[]): ClassChangeType | null => {
  const beforeIds = new Set(before);
  const afterIds = new Set(after);

  if (beforeIds.size === afterIds.size && before.every(id => afterIds.has(id))) return null;

  if (beforeIds.size === afterIds.size) return 'swapped';
  if (before.every(id => afterIds.has(id))) return 'added';
  if (after.every(id => beforeIds.has(id))) return 'removed';

  return 'replaced';
};
